'use strict';

var utils = angular.module('common.utils', []);

var EventUtil = require('./EventUtil');
var RoutingUtil = require('./RoutingUtil');
var StorageUtil = require('./StorageUtil');
var Utils = require('./Utils');

utils.service('EventUtil', EventUtil);
utils.service('RoutingUtil', RoutingUtil);
utils.factory('StorageUtil', StorageUtil);
utils.provider('Utils', Utils);


// WEBPACK FOOTER //
// ./src/common/utils/index.js